/**
 * Shared body for tenant-shell sections that have not shipped yet.
 * Renders inside the tenant chrome so the section nav stays live —
 * the shell is the persistent frame; only the body swaps.
 */
export function TenantSectionPlaceholder({ name }: { name: string }) {
  return (
    <div className="flex flex-col gap-3">
      <h2 className="font-serif text-xl tracking-tight text-neutral-900">
        {name}
      </h2>
      <p className="text-sm text-neutral-600">
        Not yet implemented — coming in a later slice.
      </p>
    </div>
  );
}
